import toast from 'react-hot-toast';

// Function for elaboration of errors from validation schema
export const processErrors = error => {
    const errorMap = {};
    let errors = [];

    if (error.details) {
        errors = error.details.map(err => {
            if (!errorMap[err.context.key]) {
                errorMap[err.context.key] = true;
                return err.message;
            }
            return null;
        }).filter(message => message !== null);
    }

    if (errors.length > 0) {
        toast.error(errors.join('\n'), { duration: 5000 });
    }
};